import { ROUTE, ROUTE_NAME } from 'enums/routes'
import { CURRENT_PROJECT_PHASE, PROJECT_PHASE } from 'enums/project-phase'

const MAIN_ROUTE_BY_PROJECT_PHASE = {
  [PROJECT_PHASE.NOMINATION]: ROUTE.HOMEPAGE,
  [PROJECT_PHASE.VOTING]: ROUTE.VOTING,
  [PROJECT_PHASE.WINNERS]: ROUTE.WINNERS
}

const ALLOWED_ROUTE_NAMES_BY_PROJECT_PHASE = {
  [PROJECT_PHASE.NOMINATION]: [
    ROUTE_NAME.HOMEPAGE,
    ROUTE_NAME.WINNERS,
    ROUTE_NAME.THANK_YOU
  ],
  [PROJECT_PHASE.VOTING]: [
    ROUTE_NAME.VOTING,
    ROUTE_NAME.WINNERS,
    ROUTE_NAME.THANK_YOU,
    ROUTE_NAME.CEO_VOTING,
    ROUTE_NAME.CEO_VOTING_THANK_YOU
  ],
  [PROJECT_PHASE.WINNERS]: [ROUTE_NAME.WINNERS]
}

export const ALLOWED_ROUTE_NAMES =
  ALLOWED_ROUTE_NAMES_BY_PROJECT_PHASE[CURRENT_PROJECT_PHASE]

/**
 * This setting controls the state of the voting
 * If set to true, the voting will be disabled
 * Note: only relevant to PROJECT_PHASE.VOTING
 * @type {boolean}
 */
export const IS_VOTING_CLOSED = true

export const MAIN_ROUTE = MAIN_ROUTE_BY_PROJECT_PHASE[CURRENT_PROJECT_PHASE]
